import { configString } from 'utils/config';

const getGradSchoolsSearchIndex = (sort: string | null | undefined) => {
  if (sort === undefined || sort === null || sort === '') {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-param-reassign
    sort = 'location-none';
  }

  const gradIndexName = configString('algolia', 'gradschoolsIndexName');
  // location-none is not a real param and sort.
  // It is used to keep the current format the frontend architecture uses
  // for default and selection/active and resolved before querying Algolia.
  // Because location search just requires plain index, and we aren't allowing sort.
  const noSort = sort === 'location-none';
  return noSort ? gradIndexName : `${gradIndexName}-${sort}`;
};

export default getGradSchoolsSearchIndex;
